import { type Brand } from '@alto/design-system';
import { isWebStaging } from './isWebStaging';
const auth0Domains: Record<Brand, Record<string, string>> = {
  alto: {
    dev: 'login.dev.alto.com',
    stg: 'login.stg.alto.com',
    prod: 'login.prod.alto.com',
  },
  fuzehealth: {
    dev: 'login.dev.pharmacy.fuzehealth.com',
    stg: 'login.stg.pharmacy.fuzehealth.com',
    prod: 'login.prod.pharmacy.fuzehealth.com',
  },
  // FuzeRx use the same auth0Domains as FuzeHealth. The plan is to use the alto-pharmacy tenant, but updating its URLs to point to FuzeHealth's
  fuzerx: {
    dev: 'login.dev.pharmacy.fuzehealth.com',
    stg: 'login.stg.pharmacy.fuzehealth.com',
    prod: 'login.prod.pharmacy.fuzehealth.com',
  },
};

export const getAuth0Domain = (backendEnv: string) => {
  // require lazily to avoid early React Native import. this fixed an issue where Jest failed to resolve getBrand()
  // which caused native tests to fail
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { getBrand } = require('../../../../libs/design-system');
  const brand: Brand = getBrand();
  const brandDomains = auth0Domains[brand];
  if (!brandDomains) throw new Error(`Unknown brand: ${brand}`);

  let env: string;

  if (isWebStaging({ backendEnv })) {
    env = 'stg';
  } else if (backendEnv === 'staging') {
    env = 'stg';
  } else if (backendEnv === 'production') {
    env = 'prod';
  } else {
    env = 'dev';
  }

  return brandDomains[env];
};

export const getAuth0ClientID = (backendEnv: string, ids: Record<Brand, Record<string, string>>) => {
  // require lazily to avoid early React Native import. this fixed an issue where Jest failed to resolve getBrand()
  // which caused native tests to fail
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { getBrand } = require('../../../../libs/design-system');
  const brand: Brand = getBrand();
  const brandIDs = ids[brand];
  if (!brandIDs) throw new Error(`Unknown brand: ${brand}`);

  if (isWebStaging({ backendEnv })) {
    return brandIDs.stg;
  }
  switch (backendEnv) {
    case 'staging':
      return brandIDs.stg;
    case 'production':
      return brandIDs.prod;
    default:
      return brandIDs.dev;
  }
};
